import { gql } from '@apollo/client';

export const DELETE_SERVICE = gql`
  mutation DeleteService($id: ID!) {
    service: deleteService(id: $id) {
      id
    }
  }
`;
